// Initialize Alpine.js

import Alpine from 'alpinejs'

import hash from './plugin.hash.js'
Alpine.plugin(hash)

import breakpoints from './plugin.breakpoints.js'
Alpine.plugin(breakpoints)

import size from './plugin.size.js'
Alpine.plugin(size)

import bodyClass from './plugin.body-class.js'
Alpine.plugin(bodyClass)

import masonry from './plugin.masonry.js'
Alpine.plugin(masonry)

import focus from '@alpinejs/focus'
Alpine.plugin(focus)

import intersect from '@alpinejs/intersect'
Alpine.plugin(intersect)

import './data.transition.js'

window.Alpine = Alpine
